import es from './locale/es.json';

/** WizzyChat: solo español. */
export default { es };
